import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import {
  condenseTaxInformation, TaxInformation, taxMapper,
} from '../../util/taxCalculatorHelpers';
import {
  applyServerLinePrices,
  ServerLinePrice,
} from '../../util/bookingReprice';

export interface AddOn {
  id: number;
  name: string;
  nameKey?: string | null;
  value: number;
  isEstimate: boolean;
  description: string;
  subDescription: string | null;
  sortOrder: number | null;
  taxName: string;
  taxPercent: number;
  taxId: number;
  serviceTypeId: number,
  serviceTypeName: string,
  discountedValue?: number
}
export interface AddOnsState {
  addOns: AddOn[];
}

const initialState: AddOnsState = {
  addOns: [],
};

export const addOnsSlice = createSlice({
  name: 'serviceTypes',
  initialState,
  reducers: {
    addAddOn: (state, action: PayloadAction<AddOn>) => {
      state.addOns.push(action.payload);
    },
    removeAddOn: (state, action: PayloadAction<number>) => (
      {
        ...state,
        addOns: state
          .addOns
          .filter((addon) => addon.id !== action.payload),
      }
    ),
    clearAllAddOns: (state) => (
      {
        ...state,
        addOns: [],
      }
    ),
    /** The server's prices for the basket (a BOOKING_PRICE_CHANGED refusal). */
    repriceAddOns: (state, action: PayloadAction<ServerLinePrice[]>) => {
      applyServerLinePrices(state.addOns, action.payload);
    },
  },
});

export const selectAddOnTotal = (
  state: RootState,
) => (state.addOns.addOns.length
  ? Math.round(state.addOns.addOns
    .map((addOn) => (
      addOn.discountedValue !== null
      && addOn.discountedValue !== undefined
      && Number.isFinite(addOn.discountedValue)
        ? addOn.discountedValue
        : addOn.value
    ))
    .reduce((prev, current) => prev + current) * 100) / 100
  : 0
);

export const selectAddOnTaxTypesAndAmounts = (
  state: RootState,
) => {
  const mappedTaxes: TaxInformation[] = state.addOns.addOns.length
    ? state.addOns.addOns.map((item) => taxMapper(item))
    : [];

  return condenseTaxInformation(mappedTaxes);
};

export const {
  addAddOn,
  removeAddOn,
  clearAllAddOns,
  repriceAddOns,
} = addOnsSlice.actions;

export const selectAddOns = (
  state: RootState,
) => state.addOns.addOns;

export default addOnsSlice.reducer;
